"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCreateReviewLink = exports.ratingsListUrl = exports.makeReviewLink = exports.makeProductReviewsPageLink = exports.makeOrganizationVitrinsPageLink = exports.makeServiceReviewsPageLink = exports.makeOrganizationServiceReviewsPageLink = exports.makeOrganizationPageLink = void 0;
const query_string_1 = __importDefault(require("query-string"));
const helpers_1 = require("./helpers");
const types_1 = require("./types");
const makeOrganizationPageLink = (alias, type) => {
    const helper = (0, helpers_1.getOrganizationHelpers)(type);
    const typeForUrl = helper.typeForService === types_1.OrganizationTypes.Mfo ? 'zaimy/mfo' : helper.itemTypeUrl;
    return `/${typeForUrl}/${alias}/`;
};
exports.makeOrganizationPageLink = makeOrganizationPageLink;
const makeOrganizationServiceReviewsPageLink = (alias, type, serviceAlias) => {
    const helper = (0, helpers_1.getOrganizationHelpers)(type);
    const typeForUrl = helper.typeForService === types_1.OrganizationTypes.Mfo ? 'zaimy/mfo' : helper.itemTypeUrl;
    return `/${typeForUrl}/${alias}/${serviceAlias}/otzyvy/`;
};
exports.makeOrganizationServiceReviewsPageLink = makeOrganizationServiceReviewsPageLink;
const makeServiceReviewsPageLink = (serviceAlias) => {
    return `/${serviceAlias}/otzyvy/`;
};
exports.makeServiceReviewsPageLink = makeServiceReviewsPageLink;
const makeOrganizationVitrinsPageLink = (alias, type, serviceAlias) => {
    const helper = (0, helpers_1.getOrganizationHelpers)(type);
    return `/${serviceAlias}/${helper.itemTypeUrl}/${alias}/`;
};
exports.makeOrganizationVitrinsPageLink = makeOrganizationVitrinsPageLink;
const makeProductReviewsPageLink = ({ organizationType, productId, organizationAlias, serviceAlias, }) => {
    const helper = (0, helpers_1.getOrganizationHelpers)(organizationType);
    return `/${helper.itemTypeUrl}/${organizationAlias}/${serviceAlias}/otzyvy/${productId}/`;
};
exports.makeProductReviewsPageLink = makeProductReviewsPageLink;
const makeReviewLink = ({ productId, organizationType, organizationAlias, serviceAlias, }) => {
    const helper = (0, helpers_1.getOrganizationHelpers)(organizationType);
    const typeForUrl = helper.typeForService === types_1.OrganizationTypes.Mfo ? 'zaimy/mfo' : helper.itemTypeUrl;
    if (productId && serviceAlias) {
        return `/${typeForUrl}/${organizationAlias}/${serviceAlias}/otzyvy/${productId}/`;
    }
    if (serviceAlias) {
        return `/${typeForUrl}/${organizationAlias}/${serviceAlias}/otzyvy/`;
    }
    return `/${typeForUrl}/${organizationAlias}/otzyvy/`;
};
exports.makeReviewLink = makeReviewLink;
const ratingsListUrl = (organizationType) => {
    const helper = (0, helpers_1.getOrganizationHelpers)(organizationType);
    return helper.ratingUrl;
};
exports.ratingsListUrl = ratingsListUrl;
const makeCreateReviewLink = ({ organizationType, organizationId, productTag, productId, rate, }) => {
    const { typeForService } = (0, helpers_1.getOrganizationHelpers)(organizationType);
    const query = query_string_1.default.stringify(Object.assign(Object.assign(Object.assign(Object.assign({ reviewObjectId: organizationId }, (organizationType && { type: typeForService })), (organizationId && { tag: productTag })), (organizationId && productId && { specificProduct: productId })), (rate && { rate: rate })));
    return `/otzyvy/add/${(query === null || query === void 0 ? void 0 : query.length) ? `?${query}` : ''}`;
};
exports.makeCreateReviewLink = makeCreateReviewLink;
